<template>
  <div class="footer flex">
    <img src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/footer-logo.png" alt=""
      class="footer-logo block" />
    <div class="mt-6 text-white text-base">
      <div class="flex space-x-4">
        <!--        <span>创大介绍</span>-->
        <!--        <span>青桔简介</span>-->
        <!--        <span>商务合作</span>-->
        <!--        <span>联系我们</span>-->
      </div>
      <div class="mt-8 space-y-1">
        <div class="footer_nav">
          <span>首页</span>
          <span>关于大赛</span>
          <span>新闻中心</span>
          <span>参赛指南</span>
          <span>支持政策</span>
          <span>大赛服务</span>
          <span>往届回顾</span>
          <span>联系我们</span>
        </div>
      </div>
      <div class="mt-8">
        <p>版权所有 :
          <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">鲁ICP备18051778号-1 潍坊创业大学 版权所有</a>
        </p>
      </div>
    </div>
    <div>
      <!-- <img src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/footer-logo.png" alt="" class="footer-logo block" /> -->

    </div>
  </div>
</template>

<style lang="scss">
.footer {
  width: 100%;
  height: 313px;
  background: #333333;
  justify-content: center;
  padding-left: 0;
}
.footer-logo {
  width: 206px;
  height: 80px;
  margin-top: 60px;
  margin-right: 100px;
}
.footer_nav span {
  margin-right: 30px;
  cursor: pointer;
}
</style>
